import styled from '@emotion/styled';

export const SponsorshipContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;

	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;

export const HeroCard = styled.section`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	padding: 3.2rem;
	border-radius: 2.4rem;
	background: linear-gradient(135deg, #0f3f7f 0%, #12539e 55%, #2f7ad5 100%);
	color: #fff;

	@media screen and (max-width: 900px) {
		padding: 2.4rem;
	}
`;

export const HeroEyebrow = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 140%;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	opacity: 0.8;
`;

export const HeroTitle = styled.h2`
	font-size: 3rem;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 135%;
	letter-spacing: -0.8px;

	@media screen and (max-width: 900px) {
		font-size: 2.4rem;
	}
`;

export const HeroDescription = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 160%;
	letter-spacing: -0.5px;
	color: rgba(255, 255, 255, 0.92);
`;

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
`;

export const Title = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;

export const Description = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 150%;
	letter-spacing: -0.6px;
	color: #495057;
`;

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	padding: 2.4rem;
	border-radius: 1.6rem;
	background-color: #f8f9fa;
	border: 1px solid #e9ecef;
`;

export const CardTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
`;

export const BulletList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding-left: 1.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 150%;
	letter-spacing: -0.6px;
	color: #495057;
	list-style: disc;
`;

export const InfoGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 2rem;

	@media screen and (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const LinkCard = styled.a`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 2.4rem;
	border-radius: 1.6rem;
	background: #f4f8fc;
	border: 1px solid #d6e4f5;
	text-decoration: none;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 12px 30px rgba(18, 83, 158, 0.12);
	}
`;

export const LinkLabel = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 140%;
	letter-spacing: -0.4px;
	color: #12539e;
`;

export const LinkTitle = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
`;

export const LinkUrl = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 150%;
	letter-spacing: -0.4px;
	color: #495057;
	word-break: break-all;
`;

export const ContactList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;

export const ContactRow = styled.div`
	display: flex;
	gap: 1.2rem;
	align-items: flex-start;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 150%;
	letter-spacing: -0.4px;
	color: #495057;
`;

export const ContactLabel = styled.span`
	min-width: 6.4rem;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	color: #212529;
`;

export const ContactValue = styled.span`
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: #495057;
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	border-top: 2px solid #00377b;

	th,
	td {
		padding: 1.6rem 1.2rem;
		border-bottom: 1px solid #dee2e6;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		line-height: 150%;
		letter-spacing: -0.4px;
		text-align: center;
		color: #212529;
	}

	th {
		background-color: #f1f3f5;
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	}

	td {
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	}
`;
